export default {
  popups: {
    info: {
      noAccessToDefaultView: 'Access to default view forbidden. Redirecting to role default view.',
      notSelectedRoleDefaultView: 'No role default view selected.',
      noAccessToRoleDefaultView: 'Access to role default view forbidden.',
    },
  },
};
